import { useCallback, useRef, useEffect } from 'react';
import throttle from 'lodash/throttle';

// Note that this needs to use the latest dependencies for the callback
const useThrottledCallback = <T extends (...args: never[]) => void>(
  callback: T,
  delay = 500,
): T => {
  const latestCallbackRef = useRef<T>(callback);
  useEffect(() => {
    latestCallbackRef.current = callback;
  });

  return useCallback(
    throttle(
      (...args: Parameters<T>) => {
        latestCallbackRef.current(...args);
      },
      delay,
      { leading: true, trailing: false },
    ),
    [],
  ) as unknown as T;
};

export default useThrottledCallback;
